import { v4 as uuidv4 } from 'uuid';
import config from '../config';

const API_BASE_URL = `${config.API_BASE_URL}/api`;

class SessionManager {
  constructor() {
    this.sessionId = null;
    this.initialized = false;
  }

  /**
   * Initialize a new session
   */
  async initSession() {
    if (this.initialized) {
      return this.sessionId;
    }

    // Generate a unique session ID
    this.sessionId = uuidv4();
    
    try {
      // Call backend to start session
      const response = await fetch(`${API_BASE_URL}/session/start`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          session_id: this.sessionId
        })
      });

      if (response.ok) {
        this.initialized = true;
        console.log('Session started:', this.sessionId);
      }
    } catch (error) {
      console.error('Error starting session:', error);
    }

    return this.sessionId;
  }

  /**
   * Get the current session ID (initialize if needed)
   */
  async getSessionId() {
    if (!this.sessionId) {
      await this.initSession();
    }
    return this.sessionId;
  }

  /**
   * Log an activity event
   */
  async logActivity(eventType, eventData = null) {
    const sessionId = await this.getSessionId();
    
    try {
      await fetch(`${API_BASE_URL}/activity/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          session_id: sessionId,
          event_type: eventType,
          event_data: eventData
        })
      });
      
      console.log('Activity logged:', eventType, eventData);
    } catch (error) {
      console.error('Error logging activity:', error);
    }
  }

  /**
   * Reset session (for starting over)
   */
  resetSession() {
    this.sessionId = null;
    this.initialized = false;
  }
}

// Create a singleton instance
const sessionManager = new SessionManager();

export default sessionManager;

// Export convenience functions
export const initSession = () => sessionManager.initSession();
export const getSessionId = () => sessionManager.getSessionId();
export const logActivity = (eventType, eventData) => sessionManager.logActivity(eventType, eventData);
export const resetSession = () => sessionManager.resetSession();
